export default __webpack_public_path__ + "static/media/partners-logo-techstorm-w@3x.d9f8aa78.webp";